// frontend/src/pages/ForgotPasswordPage.jsx
import React from "react";
import { Link } from "react-router-dom";
import ForgotPassword from "../components/ForgotPassword";

export default function ForgotPasswordPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md bg-white border rounded-xl shadow-sm p-6">
        <div className="text-center">
          <h1 className="text-xl font-semibold">Recuperar acesso</h1>
          <p className="text-sm text-gray-600 mt-1">
            Informe o e-mail da sua conta. Enviaremos um link para redefinir a senha
            (válido por 60 minutos).
          </p>
        </div>

        <div className="mt-6">
          <ForgotPassword standalone />
        </div>

        <div className="mt-6 text-center text-sm">
          <Link to="/login" className="text-emerald-700 hover:underline">
            Voltar ao login
          </Link>
        </div>
      </div>
    </div>
  );
}